import { PaneArea } from '../../types/shared'
import { IScaledLineAttrs } from '../canvas/scaled_line'
import VerticalLine from '../canvas/vertical_line'
import PaneModel from '../models/pane'

type Area = PaneArea
type Attrs = IScaledLineAttrs
type PartialAttrs = Partial<Attrs>

class VerticalLineCreator extends VerticalLine<Attrs> {
  isCreator = true

  constructor(startArea: Area, values: PartialAttrs, model: PaneModel, _: unknown, toolsCallback: () => void) {
    super(values, model)
    this.toolsCallback = toolsCallback
    window.gtag?.('event', 'create', { event_category: 'tools', event_label: this.name })
  }

  onMouseUp(area: Area) {
    this.attrs.x1 = area.x
    this.attrs.x2 = area.x
    this.release()
    this.replaceMyself(VerticalLine.fromObject<VerticalLine>(this.attrs, this.model))
    this.toolsCallback()
  }
}

export default VerticalLineCreator
